import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import generic from '../constants/generic'

Vue.use(VueRouter);

// Extract locale from url: /<LANG>/loan-enquiry/app/eligibility
const i = location.pathname.toLowerCase().indexOf('/loan-enquiry');
const locale = location.pathname.substring(0, i);

let routerBasePath = locale + '/loan-enquiry/';

const router = new VueRouter({
  mode: 'history',
  base: routerBasePath,
  routes,
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  document.title = `${generic.OpenModuleTitle} :: ${to.name ? to.name : ""}`;
  next();
});

export default router;
